
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {dictApi, roleApi, userApi} from "@/api/organization";
    import baseUrl, {imageUrl} from "@/constants";
    const {CodeToText, regionData} =require("@/js/region/region");
    import UserData0 from "@/components/UserData0.vue"
    import OrganizationTable2 from "@/components/OrganizationTable2.vue"
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import reasons from "@/components/Reasons2.vue"; //简单版
    @Component({
        name:'Sys_UserManage',
        components: {UserData0,OrganizationTable2,SetTableColumns,reasons}
    })
    export default class Home extends Vue {
        title = "用户管理";
        titleObj = {
            "0": "个人注册审核",
            "1": "用户管理",
            "3": "绑定单位审核",
        }
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        form = {
            loginName: "",  //用户名
            type: "",  //用户类型
            idCard: "",  //身份证号
            name: "",  //真实姓名
            phone: "",  //手机号码
            organizationName: "",  //单位名称
            organizationType: "",  //单位类型
            organizationRegion: "",//单位所在区域
        } as any
        showForm = false;

        editId = 0;
        setDialog = false;   //个人简单信息
        setDialog2 = false;  //单位信息
        setDialog3 = false;  //个人基础信息组件弹窗
        setDialog4 = false;  //单位信息2
        dialog4Id = 0;
        allSelected = [];
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        listForm = {
            //开展的检定/校准项目
            items : [],
            rules: {
                orderIndex: [{ required: true, message: '请输入排序', trigger: 'blur' }],
            }
        };
        userForm = {
            name: "",
            idCard: "",
            userName: "",
            phone: "",
            id: ""
        }
        organizationForm = null as any
        baseUrl = baseUrl
        imageUrl = imageUrl
        regionData = regionData
        CodeToText = CodeToText
        status = "1";  //0未审核  1已审核  3单位未审核
        type = "1";  //0所有  1单个单位
        mechanismTypeData = {};//单位类别
        mechanismTypeList = [];

        levelData = {}; //单位级别
        failDialog = false;  //不通过原因
        failText = "";
        failDialog2 = false;  //不通过原因
        failText2 = "";
        //角色
        roleDialog = false;
        roleArr = [];  //角色备选列表
        roleIds = [];  //选中的角色

        tabCol = [];
        tableKey = 0;
        userData = {} as any; //当前登陆用户信息

        created() {
            this.userData = this.$store.state.AuthedUser;
            this.init();
        }
        init(){
            this.status = this.$route.params.status;
            this.type = this.$route.params.type;
            this.listDict();
            this.list();
            this.listRole();
        }
        // @Watch("$route.path")
        // get$routePath(){
        //     this.init();
        // }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }
        //获取角色
        listRole(){
            roleApi.list(1,undefined).then((r:any)=>{
                if(r.data.result === 0){
                    this.roleArr = r.data.data;
                }
            })
        }
        list() {
            const userData = this.$store.state.AuthedUser;
            const params = {
                ...this.listParam,
                ...this.form,
                login: 1,
                status: this.status,
                organizationId: this.type=="1"?userData.organizationId:null
            }
            let api;
            if(this.status == "0"){
                api = userApi.registerUserList(params)
            }else{
                api = userApi.listLoginUsers(params)
            }
            api.then(r => {
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.listForm.items = rData.records;
                    this.listTotal = rData.total;
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            })
        }
        reset(){
            for(const f in this.form){
                this.form[f] = "";
            }
            this.refresh();
        }
        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }
        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }
      bindUpdateBtn(mode: string) {
        const dataArr = this.allSelected as any;
        if (dataArr.length == 0) {
          this.$message.error("请先勾选");
          return;
        }
        const ids = dataArr.flatMap( (e: any) => e.userId);
        const activeStatus = "batch-enable" === mode ? 1 : 2;
        this.batchEditActiveStatus(activeStatus, ids);
      }
      batchEditActiveStatus(activeStatus: number, list: Array<string>) {
        this.$confirm('您勾选了'+ list.length +'条数据，确定要将用户状态切换到【' + (activeStatus === 1 ? '正常' : '禁用') +'】吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userApi.batchEditActiveStatus(activeStatus, list).then((r: any) => {
            if(r.data.result === 0) {
              this.$message.success("操作成功!");
              this.handleClick();
            }
          });
        });
      }

        queryPwd(id: string){
            userApi.queryPwd(id).then(r => {
                this.$alert("用户密码为：<br><br>" + r.data.data, {dangerouslyUseHTMLString: true});
            })
        }

        //0新增  1编辑 2查看  3删除  4解绑 5重置密码 6审核 7设置角色
        toDetail(type: number){
            const dataArr = this.allSelected as any;
            let id = 0;
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.del(dataArr);
                    return;
                }
                if(type == 5){
                    this.resetPass(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2 || type == 4 || type == 6 || type == 7)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
            }
            this.editId = id;
            if(type == 4){
                this.unbind(id);
                return
            }
            //设置角色弹窗
            if(type == 7){
                this.setRole(dataArr[0]);
                return
            }
            this.setDialog = true;
            if(type == 6 ){
                this.userForm = dataArr[0];
            }
        }
        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }

        setRole(data: any){
            userApi.loadDetail({id: data.userId}).then(r => {
                this.roleDialog = true;
                if (r.data.result === 0) {
                    this.editId = data.userId;
                    const rData = r.data.data as any;
                    if(rData.roleIds){
                        this.roleIds = rData.roleIds;
                    }else{
                        this.roleIds = [];
                    }
                }
            })
        }
        clearSelectedTable(){
          this.allSelected = [];
          let $table = this.$refs.table as HTMLFormElement;
          if($table){
            $table.clearSelection();
          }
        }
        saveRoleBtn(){
            userApi.setUserRole({userId: this.editId, roleIds: this.roleIds.join(",")}).then(r => {
                if (r.data.result === 0) {
                    this.$message.success("保存成功");
                    this.roleDialog = false;
                    this.clearSelectedTable();
                }
            })
        }

        showUser(row: any){
            this.userForm = row;
            this.setDialog = true;
            // if(this.status == "0"){
            //     this.setDialog = true;
            // }else{
            //     this.setDialog3 = true;
            // }
        }
        showOrganization(row: any){
            this.dialog4Id = row.organizationId;
            this.setDialog4 = true;
            // const params = {
            //     size: 1,
            //     current: 1,
            //     organizationId: row.organizationId,
            //     status: 1
            // }
            // mechanismApi.list(params).then(r => {
            //     if (r.data.result === 0) {
            //         const rData = r.data.data.records;
            //         if(rData.length > 0){
            //             this.organizationForm = rData[0];
            //             this.setDialog4 = true;
            //         }
            //     }
            // })
        }
        listDict(){
            //单位类别
            dictApi.listDictItem({typeCode : "dwlb"}).then((r) => {
                if(r.data.result === 0){
                    const mechanismTypeData = {} as any;
                    const dataList = r.data.data;
                    dataList.forEach((d: any) => {
                        mechanismTypeData[d.dictKey] = d;
                    });
                    this.mechanismTypeData = mechanismTypeData;
                    this.mechanismTypeList = dataList;
                }
            });

            //单位级别
            dictApi.listDictItem({typeCode : "dwjb"}).then((r) => {
                if(r.data.result === 0){
                    const levelData = {} as any;
                    const dataList = r.data.data;
                    dataList.forEach((d: any) => {
                        levelData[d.dictKey] = d;
                    });
                    this.levelData = levelData;
                }
            });
        }

        unbind(id: any){
            this.$confirm('确定要解绑单位吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userApi.unBind({userId:id}).then((r: any) => {
                    if (r.data.result === 0) {
                        this.$message.success("解绑成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        resetPass(dataArr: any){
            this.$confirm('确定要重置'+dataArr.flatMap((e:any)=>e.name).join(",")+'的密码？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userApi.resetUserPass({userId: dataArr.flatMap((e:any)=>e.userId).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("重置成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

      del(dataArr: any) {
        const sysAdmin = dataArr.filter((e: any) => e.id == null);
        if (sysAdmin.length > 0) {
          this.$message.error("单位管理员用户不可删除！");
          return;
        }
        this.$confirm('确定要删除' + dataArr.flatMap((e: any) => e.name).join(",") + '？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userApi.delUser({ids: dataArr.flatMap((e: any) => e.id).join(","), type: 1}).then(r => {
            if (r.data.result === 0) {
              this.$message.success("删除成功");
              this.handleClick();
            }
          })
        }).catch(() => {
          console.log("取消")
        });
      }
        handleClick(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
            this.list();
            // this.refresh();
        }
        refresh() {
            this.listParam.current = 1;
            this.list();
        }
        //通过或不通过
        passOrNot(status: number){
            const reasons = this.$refs.reasons as HTMLFormElement;

            const obj = {
                userId: this.userForm.id,
                status: status
            } as any
            if(status == 2){
                //不通过，必须有原因
                const failText = reasons.getText();
                if(failText == ""){
                    this.$message.error("请填写不通过原因");
                    return
                }
                obj.reason = failText;
            }
            userApi.passOrNot(obj).then(r => {
                if (r.data.result === 0) {
                    this.$message.success("审核成功");
                    this.failDialog = false;
                    this.setDialog = false;
                    this.handleClick();
                }
            })
        }
        //绑定单位通过或不通过
        bindPassOrNot(status: number){
            const obj = {
                userId: this.userForm.id,
                status: status
            } as any
            if(status == 0){
                //不通过，必须有原因
                const failText = this.failText2;
                if(failText == ""){
                    this.$message.error("请填写不通过原因");
                    return
                }
                obj.reason = failText;
            }
            userApi.bindPassOrNot(obj).then(r => {
                if (r.data.result === 0) {
                    this.$message.success("审核成功");
                    this.failDialog2 = false;
                    this.setDialog3 = false;
                    this.setDialog = false;
                    this.handleClick();
                }
            })
        }
    }
